import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { EDateFormat } from '@pc/common';

export const DYNAMIC_FORMATS: MatDateFormats = {
  parse: {
    dateInput: EDateFormat.FORMAT_DDMMYYY
  },
  display: {
    dateInput: EDateFormat.FORMAT_DDMMYYY,
    monthYearLabel: EDateFormat.MONTH_YEAR_LABEL_MMMYYYY,
    dateA11yLabel: EDateFormat.DATE_ACCESSIBILITY_LABEL_LL,
    monthYearA11yLabel: EDateFormat.MONTH_YEAR_ACCESSIBILITY_LABEL_MMMM_YYYY
  }
};

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    monthYearLabel: { year: 'numeric', month: 'long' }
  }
};
